import {ForkygramCollaboratorMemberData} from 'types'
import {REDUX_STORE} from 'lib/redux'
import {getDefaultAvatar} from 'utils/account'

function getRandomMember<T extends ForkygramCollaboratorMemberData>(
  members: T[],
): T {
  return members[Math.floor(Math.random() * members.length)]
}

export function getCollabMemberId(member: ForkygramCollaboratorMemberData) {
  return 'member_id' in member ? member.member_id : member.id
}

export function getCollaboratorMember<
  T extends ForkygramCollaboratorMemberData
>(
  data: ReadonlyArray<T>,
): {
  collaboratorOwner: T
  collaboratorMember: T | null
  collaboratorSelf: T | null
} {
  const {id} = REDUX_STORE.getState().user || {}

  const fallbackOwner: ForkygramCollaboratorMemberData = {
    id: '',
    member_id: '',
    username: '',
    photo: getDefaultAvatar(),
    creator_status: 'unverified',
    is_official: false,
    is_followed: false,
    is_live: false,
    is_owner: true,
  }

  const collaboratorSelf =
    (data.length > 1 &&
      data.find((x) => !x.is_owner && getCollabMemberId(x) === id)) ||
    null

  const collaboratorMember =
    (data.length > 1 && data.find((x) => !x.is_owner)) || null

  const ownerCandidates = data.filter((x) => x !== collaboratorMember)

  const collaboratorOwner =
    data.length === 1
      ? data[0]
      : data.find((x) => x.is_owner && getCollabMemberId(x) === id) ||
        data.find((x) => x.is_owner) ||
        getRandomMember(ownerCandidates)

  return {
    collaboratorOwner: collaboratorOwner || fallbackOwner,
    collaboratorMember,
    collaboratorSelf,
  }
}
